import React, { useState } from "react";

function ReportsExpand({
  title,
  isFavorite,
  inFavoritesSection,
  toggleFavorite,
  children,
  dragHandle,
  onExpand,
  ...rest
}) {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div {...rest}>
        <div className="h5 clearfix">
          <div className="float-start">
            <i
              title="Expand"
              className={
                expanded
                  ? "fas fa-chevron-up p-1 text-primary"
                  : "fas fa-chevron-down p-1 text-primary"
              }
              onClick={() => {
                setExpanded(!expanded);

                if (onExpand) {
                  onExpand();
                }
              }}
            ></i>
            {title}
          </div>
          {/* <div className="float-end">
            <i
              className={
                isFavorite ? "fas fa-star align-top" : "far fa-star align-top"
              }
              title={isFavorite ? "Remove Favorite" : "Add Favorite"}
              onMouseDown={() => {
                toggleFavorite(title);
              }}
            ></i>
            {isFavorite && inFavoritesSection ? (
              <span className="ms-2">{dragHandle}</span>
            ) : null}
          </div> */}
        </div>
        {expanded ? children : null}
      </div>
    </>
  );
}

export default ReportsExpand;
